<template>
    <div class="parking-plan">
        <!-- Выбора машиноместа -->
        <div class="parking-plan__floor">
            <Canvas v-if="floor && elements"
                    :floor="floor"
                    :elements="elements"
                    @clickElement="$emit('clickElement', $event)"/>
        </div>

        <div class="parking-plan__filter">
            <FilterPlan :filters="filtersArea"/>
        </div>

        <!-- Выбор этажа на десктопах -->
        <div v-if="floor && floors && floors.length" class="parking-plan__sly-floor">
            <div class="parking-plan__sly-floor-ttl">
                <div class="parking-plan__sly-floor-ttl-item">В продаже</div>
                <div class="parking-plan__sly-floor-ttl-item">Этаж</div>
            </div>
            <div class="parking-plan__sly-floor-list">
                <Sly :list="floors" :activeId="floorId" modify="is-floor" @click="setFloor"/>
            </div>
        </div>

        <!-- Тугл для выбора этажа -->
        <div v-if="floor && floor.number"
             class="parking-plan__fix-floor"
             @click="floorPopup = true">
            <span>{{ floor.number }} этаж</span>
            <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.146447 10.1464C0.341709 9.95118 0.658291 9.95118 0.853554 10.1464L3.5 12.7929L6.14645 10.1464C6.34171 9.95118 6.65829 9.95118 6.85355 10.1464C7.04882 10.3417 7.04882 10.6583 6.85355 10.8536L3.85355 13.8536C3.65829 14.0488 3.34171 14.0488 3.14645 13.8536L0.146447 10.8536C-0.0488154 10.6583 -0.0488154 10.3417 0.146447 10.1464Z" fill="#2C2925"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.85355 3.85355C6.65829 4.04882 6.34171 4.04882 6.14645 3.85355L3.5 1.20711L0.853553 3.85355C0.658291 4.04882 0.341709 4.04882 0.146447 3.85355C-0.0488156 3.65829 -0.0488156 3.34171 0.146447 3.14645L3.14645 0.146447C3.24021 0.0526783 3.36739 0 3.5 0C3.63261 0 3.75979 0.0526783 3.85355 0.146447L6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355Z" fill="#2C2925"/></g></svg>
        </div>

        <!-- Попап для выбора дома -->
        <div class="parking-plan__popup-floor">
            <transition name="fade">
                <div v-show="floorPopup" class="parking-plan__popup-floor-inner">
                    <div class="parking-plan__popup-close" @click="floorPopup = false">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.232333 0.232333C-0.0774444 0.542111 -0.0774444 1.04436 0.232333 1.35414L3.8782 5L0.232333 8.64586C-0.0774444 8.95564 -0.0774444 9.45789 0.232333 9.76767C0.542111 10.0774 1.04436 10.0774 1.35414 9.76767L5 6.1218L8.64586 9.76767C8.95564 10.0774 9.45789 10.0774 9.76767 9.76767C10.0774 9.45789 10.0774 8.95564 9.76767 8.64586L6.1218 5L9.76767 1.35414C10.0774 1.04436 10.0774 0.542111 9.76767 0.232333C9.45789 -0.0774444 8.95564 -0.0774444 8.64586 0.232333L5 3.8782L1.35414 0.232333C1.04436 -0.0774444 0.542111 -0.0774444 0.232333 0.232333Z" fill="#2C2925"/></svg>
                    </div>

                    <div class="parking-plan__popup-floor-content">
                        <Sly :list="floors" :activeId="floorId" modify="is-floor" @click="setFloor"/>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import Canvas from '../Canvas/Canvas.vue';
import FilterPlan from '../FilterPlan/FilterPlan.vue';
import Sly from '../Sly/Sly.vue';

export default {
    components: {
        Canvas,
        FilterPlan,
        Sly
    },

    props: ['data'],

    data: () => {
        return {
            floorId   : null,
            floorPopup: false
        };
    },

    computed: {
        floors() {
            return this.data && this.data.floors ? Array.from(this.data.floors) : null;
        },

        floor() {
            if (this.floors && this.floors.length) {
                return Array.from(this.floors).find((floor) => {
                    return Number(floor.id) === Number(this.floorId);
                });
            }

            return null;
        },

        totalElements() {
            return this.data && this.data.elements ? Array.from(this.data.elements) : null;
        },

        elements() {
            if (this.totalElements && this.totalElements.length) {
                let elementsFilter = this.totalElements.filter((element) => {
                    return Number(element.floor) === Number(this.floorId);
                });

                if (this.filtersArea.length) {
                    const checked = this.filtersArea.filter((filter) => {
                        return filter.checked && !filter.disabled;
                    });
                    const value = checked.map((filter) => {
                        return filter.value instanceof Object ? filter.value : `${filter.value}`;
                    });

                    if (value.length) {
                        elementsFilter = elementsFilter.filter((element) => {
                            let check = false;

                            value.forEach((val) => {
                                if (val instanceof Object &&
                                    Number(element.area) >= Number(val.from) &&
                                    Number(element.area) <= Number(val.to)) {
                                    check = true;
                                } else if (val === `${element.area}`) {
                                    check = true;
                                }
                            });

                            return check;
                        });
                    }
                }

                return elementsFilter;
            }

            return null;
        },

        filtersArea() {
            return (this.data && this.data.filters && this.data.filters.area) || null;
        }
    },

    mounted() {
        this.setStartFloor();
    },

    methods: {
        setFloor(floor) {
            if (floor && floor.id) {
                this.floorId = floor.id;
            }

            this.floorPopup = false;
        },

        setStartFloor() {
            this.floorId = this.floors.find((element) => {
                return !element.disabled;
            }).id;
        }
    }
};


</script>

